import { NgModule } from '@angular/core';
import { BnpOidcHelperLoginComponent } from './bnp-oidc-helper-login.component';

@NgModule({
  declarations: [BnpOidcHelperLoginComponent],
  imports: [
  ],
  exports: [BnpOidcHelperLoginComponent]
})
export class BnpOidcHelperLoginModule { }
